<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Keyword" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">公告类:</div>
                <el-select v-model="conditionData.SealFileType" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in fileTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">一审状态:</div>
                <el-select v-model="conditionData.FirstExamineStatus" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in auditStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!-- <div class="item">
                <div class="label">终审状态:</div>
                <el-select v-model="conditionData.EndExamineStatus" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in auditStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
           
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog()">新建</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="agent"
                label="经办人"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="departmentJson"
                label="用印部门"
                align="center"
                width="200px"
                :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                prop="sealDate"
                label="用印日期"
                align="center"
                width="180px"
                >
                </el-table-column>
                <el-table-column
                prop="sealFileName"
                label="用印文件名称"
                align="center"
                width="180px"
                :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                prop="fileNum"
                label="文件份数"
                align="center"
                >
                </el-table-column>

                <el-table-column
                prop="sealFileType"
                label="公告类"
                align="center"
                >
                </el-table-column>
               
                <el-table-column
                prop="cCtoName"
                label="抄送人"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="firstShenName"
                label="一审人"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="firstShenTime"
                label="一审时间"
                align="center"
                width="180px"
                >
                </el-table-column>
                <el-table-column
                prop="firstShenRemark"
                label="一审备注"
                align="center"
                width="180px"
                :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                prop="endShenName"
                label="终审人"
                align="center"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="endExamineStatus"
                label=""
                align="center"
                >
                </el-table-column> -->
                <el-table-column
                prop="endShenTime"
                label="终审时间"
                align="center"
                width="180px"
                >
                </el-table-column>
                <el-table-column
                prop="endShenRemark"
                label="终审备注"
                align="center"
                width="180px"
                :show-overflow-tooltip="true"
                >
                </el-table-column>
                
                <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    <!-- <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button> -->
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isAuditDialogShow(scope.row)">审核</el-button>
                    <!-- <el-button type="text" icon="el-icon-delete" size="mini" @click="isDeleteShow(scope.row)">删除</el-button> -->
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>


        <el-dialog :visible.sync="isAddDialog" title="新增" width="980px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        经办人
                    </div>
                    <div class="value">
                        <el-input v-model="addData.agent" size="small" placeholder="请输入" @focus="selectAddData(0)"></el-input>
                    </div>
                </div>
                
                <div class="item item-b">
                    <el-button icon="el-icon-circle-plus" type="primary" style="margin-bottom:5px;margin-right:20px" size="small" @click="isSelectDepartment = true">添加事业部</el-button>
                    <el-tag
                    v-for="(item,index) in businessList"
                    :key="index"
                    closable
                    style="margin-bottom:5px;margin-right:20px"
                    @close="closeBusiness(index)"
                    >
                    {{item}}
                    </el-tag>
                </div>
                <div class="item">
                    <div class="label">
                        用印日期
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addData.sealDate"
                        type="date"
                        size="small"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用印文件名称:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.sealFileName" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件份数:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.fileNum" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件类型:
                    </div>
                    <div class="value">
                        <el-select v-model="addData.sealFileType" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in fileTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" style="width:100%">
                    <div class="label">
                        文件上传:
                    </div>
                    <div class="imgList">
                        <el-upload
                        :action="uploadUrl"
                        multiple
                        :show-file-list="false"
                        :http-request="fileUpload"
                        >
                            <el-button icon="el-icon-upload2" type="primary" style="margin-bottom:10px" size="small">上传</el-button>
                        </el-upload>
                        <div class="item-imgs">
                            <div style="width: 100px; height: 100px" class="item-img" v-for="(item,index) in filePathJson" :key="index">
                                <div class="icon" @click="deleteImg(index)">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="item"
                                :fit="cover"
                                @click="showImg(item)" 
                                ></el-image>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        抄送人:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.cCtoName" size="small" placeholder="请输入" @focus="selectAddData(1)"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        一审人:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.firstShenName" size="small" placeholder="请输入" @focus="selectAddData(2)"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        一审状态:
                    </div>
                    <div class="value">
                        <el-select v-model="addData.firstExamineStatus" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in auditStatusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        一审时间:
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addData.firstShenTime"
                        type="date"
                        size="small"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        一审备注:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.firstShenRemark" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        终审人:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.endShenName" size="small" placeholder="请输入" @focus="selectAddData(3)"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        终审状态:
                    </div>
                    <div class="value">
                        <el-select v-model="addData.endExamineStatus" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in auditStatusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        终审时间:
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addData.endShenTime"
                        type="date"
                        size="small"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        终审备注:
                    </div>
                    <div class="value">
                        <el-input v-model="addData.endShenRemark" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAddDialog = false">取 消</el-button>
                    <el-button type="primary" @click="addDataFun">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :visible.sync="isUpdateDialog" title="编辑" width="980px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        经办人
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.agent" size="small" placeholder="请输入" @focus="selectAddData(0)"></el-input>
                    </div>
                </div>
                
                <div class="item item-b">
                    <el-button icon="el-icon-circle-plus" type="primary" style="margin-bottom:5px;margin-right:20px" size="small" @click="isSelectDepartment = true">添加事业部</el-button>
                    <el-tag
                    v-for="(item,index) in businessList"
                    :key="index"
                    closable
                    style="margin-bottom:5px;margin-right:20px"
                    @close="closeBusiness(index)"
                    >
                    {{item}}
                    </el-tag>
                </div>
                <div class="item">
                    <div class="label">
                        用印日期
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="updateData.sealDate"
                        type="date"
                        size="small"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用印文件名称:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.sealFileName" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件份数:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.fileNum" size="small" placeholder="请输入" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件类型:
                    </div>
                    <div class="value">
                        <el-select v-model="updateData.sealFileType" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in fileTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" style="width:100%">
                    <div class="label">
                        文件上传:
                    </div>
                    <div class="imgList">
                        <el-upload
                        :action="uploadUrl"
                        multiple
                        :show-file-list="false"
                        :http-request="fileUpload"
                        >
                            <el-button icon="el-icon-upload2" type="primary" style="margin-bottom:10px" size="small">上传</el-button>
                        </el-upload>
                        <div class="item-imgs">
                            <div style="width: 100px; height: 100px" class="item-img" v-for="(item,index) in filePathJson" :key="index">
                                <div class="icon" @click="deleteImg(index)">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="item"
                                :fit="cover"
                                @click="showImg(item)" 
                                ></el-image>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        抄送人:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.cCtoName" size="small" placeholder="请输入" @focus="selectAddData(1)"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        一审人:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.firstShenName" size="small" placeholder="请输入" @focus="selectAddData(2)"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        一审状态:
                    </div>
                    <div class="value">
                        <el-select v-model="updateData.firstExamineStatus" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in auditStatusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        一审时间:
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="updateData.firstShenTime"
                        type="date"
                        size="small"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        一审备注:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.firstShenRemark" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        终审人:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.endShenName" size="small" placeholder="请输入" @focus="selectAddData(3)"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        终审状态:
                    </div>
                    <div class="value">
                        <el-select v-model="updateData.endExamineStatus" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in auditStatusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        终审时间:
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="updateData.endShenTime"
                        type="date"
                        size="small"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        终审备注:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.endShenRemark" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isUpdateDialog = false">取 消</el-button>
                    <el-button type="primary" @click="updateDataFun">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="isUserDialog" title="选择员工" width="1200px">
            <div class="condition">
                <div class="item">
                    <div class="label">综合查询:</div>
                    <el-input v-model="conditionUserData.Keyword" size="small" placeholder="综合查询"></el-input>
                </div>
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectUserData()">查询</el-button>
                    <el-button type="" size="small" @click="resetUserData()">重置</el-button>
                </div>
            </div>

            <div class="table">
                <el-table
                :data="userList"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                prop="jobNumber"
                label="工号"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="姓名"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismName"
                label="机构"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="businessName"
                label="部门"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="sheBaoNum"
                label="个人电脑号"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="sex"
                label="性别"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="联系电话"
                align="center"
                width="150"
                >
                </el-table-column>
                <el-table-column
                prop="isWaiPai"
                label="是否外派"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.isWaiPai">
                        是
                    </span>
                    <span v-else>
                        否
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="isPaySheBao"
                label="是否购买社保"
                align="center"
                width="150"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.isPaySheBao">
                        是
                    </span>
                    <span v-else>
                        否
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="isPayGongJiJin"
                label="是否购买公积金"
                align="center"
                width="150"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.isPayGongJiJin">
                        是
                    </span>
                    <span v-else>
                        否
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="ruZhiDate"
                label="入职时间"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="affirm(scope.row)">确认员工</el-button>
                </template>
                </el-table-column>
            </el-table>
            </div>

        </el-dialog>

        <el-dialog :visible.sync="auditDialogShow" title="审核" width="980px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        经办人
                    </div>
                    <div class="value">
                        <el-input v-model="auditData.agent" size="small" placeholder="请输入" @focus="selectAddData(0)" disabled></el-input>
                    </div>
                </div>
                
                <div class="item item-b">
                    <el-button icon="el-icon-circle-plus" type="primary" style="margin-bottom:5px;margin-right:20px" size="small" @click="isSelectDepartment = true">添加事业部</el-button>
                    <el-tag
                    v-for="(item,index) in businessList"
                    :key="index"
                    style="margin-bottom:5px;margin-right:20px"
                    >
                    {{item}}
                    </el-tag>
                </div>
                <div class="item">
                    <div class="label">
                        用印日期
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="auditData.sealDate"
                        type="date"
                        size="small"
                        disabled
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用印文件名称:
                    </div>
                    <div class="value">
                        <el-input v-model="auditData.sealFileName" size="small" placeholder="请输入" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件份数:
                    </div>
                    <div class="value">
                        <el-input v-model="auditData.fileNum" size="small" placeholder="请输入" type="number" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件类型:
                    </div>
                    <div class="value">
                        <el-select v-model="auditData.sealFileType" size="small" placeholder="请选择" disabled>
                            <el-option
                            v-for="item in fileTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" style="width:100%">
                    <div class="label">
                        文件上传:
                    </div>
                    <div class="imgList">
                        <div class="item-imgs">
                            <div style="width: 100px; height: 100px" class="item-img" v-for="(item,index) in filePathJson" :key="index">
                                <div class="icon" @click="deleteImg(index)">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="item"
                                :fit="cover"
                                @click="showImg(item)" 
                                ></el-image>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        抄送人:
                    </div>
                    <div class="value">
                        <el-input v-model="auditData.cCtoName" size="small" placeholder="请输入" @focus="selectAddData(1)" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        一审人:
                    </div>
                    <div class="value">
                        <el-input v-model="auditData.firstShenName" size="small" placeholder="请输入" @focus="selectAddData(2)" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        一审状态:
                    </div>
                    <div class="value">
                        <el-select v-model="auditData.firstExamineStatus" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in auditStatusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        一审时间:
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="auditData.firstShenTime"
                        type="date"
                        size="small"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        一审备注:
                    </div>
                    <div class="value">
                        <el-input v-model="auditData.firstShenRemark" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        终审人:
                    </div>
                    <div class="value">
                        <el-input v-model="auditData.endShenName" size="small" placeholder="请输入" @focus="selectAddData(3)" disabled></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        终审状态:
                    </div>
                    <div class="value">
                        <el-select v-model="auditData.endExamineStatus" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in auditStatusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        终审时间:
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="auditData.endShenTime"
                        type="date"
                        size="small"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        终审备注:
                    </div>
                    <div class="value">
                        <el-input v-model="auditData.endShenRemark" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div slot="footer" class="dialog-footer">
                    <el-button @click="auditDialogShow = false">取 消</el-button>
                    <el-button type="primary" @click="auditDataFun">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="isAgentListDialog" title="选择经纪人" width="1200px">
            <div class="condition">
                <div class="item">
                    <div class="label">人员名称:</div>
                    <el-input v-model="conditionAgentData.Name" size="small" placeholder="人员名称"></el-input>
                </div>
                <div class="item">
                    <div class="label">账号:</div>
                    <el-input v-model="conditionAgentData.Phone" size="small" placeholder="账号"></el-input>
                </div>
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectAgentData()">查询</el-button>
                    <el-button type="" size="small" @click="resetAgentData()">重置</el-button>
                </div>
            </div>

            <div class="table">
                <el-table
                :data="agentList"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="用户名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="账号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="roleNames"
                label="关联角色"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="enable"
                label="是否启用"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.enable">启用</span>
                    <span v-else>禁用</span>
                </template>
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="affirmAgent(scope.row)">确认</el-button>
                    <!-- <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteUser(scope.row)">删除</el-button> -->
                </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="page">
                <el-pagination
                @current-change="handleCurrentChangeAgent"
                    background
                    layout="prev, pager, next"
                    :total="agentTotalCount"
                    :current-page="conditionAgentData.page"
                    :page-size="conditionAgentData.pageSize">
                </el-pagination>
                
            </div>
        </el-dialog>
        
        <el-dialog :visible.sync="isSelectDepartment" title="选择事业部" width="960px">
            <div class="condition">
                <div class="item" style="border:0">
                    <div class="label">分公司/机构名称:</div>
                    <el-input v-model="departmentConditionData.Name" size="small" placeholder="请输入" style="width:300px"></el-input>
                </div>
            
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectDepartmentData()">查询</el-button>
                    <el-button type="" size="small" @click="resetDepartment()">重置</el-button>
                </div>
            </div>

            <el-table
                :data="departmentList"
                style="width: 100%">
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="code"
                label="事业部编号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="事业部名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="contacts"
                label="事业部联系人"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="contactsPhone"
                label="联系人电话"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="businessPerson"
                label="事业部负责人"
                align="center"
                >
                </el-table-column>
                
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-circle-check" size="mini" @click="affirmDepartment(scope.row,scope.$index)">选择</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleDepartmentCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="departmentTotalCount"
                    :current-page="departmentConditionData.page"
                    :page-size="departmentConditionData.pageSize">
                </el-pagination>
            </div>
        </el-dialog>
        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionDataPlus , CodeToText } from "element-china-area-data";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            selectedOptions:[],
            parentDialog:false,
            title:'',
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                SealFileType:null,
                FirstExamineStatus:null,
                EndExamineStatus:null,
                Keyword:'',
                page:1,
                pageSize:10,
            },
            parentName:'',
            addData:{},
            updateData:{},
            auditData:{},
            tableData:[],
            userList:[],
            userTotal:0,
            userDialog:false,
            conditionUserData:{
                Keyword:'',
                Name:'',
                Sex:'',
                Phone:'',
                MinZu:'',
                IdCard:'',
                HuKouType:'',
                ZzMm:'',
                ZgXl:'',
                page:1,
                pageSize:10,
            },
            isUserDialog:false,
            selectType:0,
            auditStatusList:[{
                label:'审核不通过',
                value:-1,
            },{
                label:'待审核',
                value:1,
            },{
                label:'审核通过',
                value:2,
            }],
            fileTypeList:[{
                label:'公告类',
                value:1,
            },{
                label:'规章制度类',
                value:2,
            },{
                label:'合同类',
                value:3,
            },{
                label:'文件',
                value:4,
            }],
            filePathJson:[],
            showBigImg:false,
            showBigImgList:[],
            auditDialogShow:false,

            isAgentListDialog:false,
            agentList:[],
            agentTotalCount:0,
            conditionAgentData:{
                Name:'',
                Phone:'',
                page:1,
                pageSize:10,
            },
            
            departmentList:[],
            isSelectDepartment:false,
            departmentTotalCount:0,
            departmentConditionData:{
                Name:'',
                page:1,
                pageSize:10,
            },
            businessList:[],
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
        this.loadingUserList();
        this.loadingAgentList();
        this.geDepartment();
    },
    methods:{
       
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.sealVerificationQueryPager(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                SealFileType:null,
                FirstExamineStatus:null,
                EndExamineStatus:null,
                Keyword:'',
                page:1,
                pageSize:10,
                
            },
            this.selectedOptions=[];
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.isAddDialog = true;
        },
        async addDataFun(){
            this.addData.firstExamineStatus = 1;
            this.addData.endExamineStatus = 1;
            this.addData.fileNum = parseInt(this.addData.fileNum);
            this.addData.filePathJson = JSON.stringify(this.filePathJson);
            this.addData.departmentJson = '';
            for(let index in this.businessList){
                if(index==0){
                    this.addData.departmentJson = this.businessList[index];
                }else{
                    this.addData.departmentJson = this.addData.departmentJson+','+ this.businessList[index];
                }
            }
            let res  = await api.sealVerificationAddAsync(this.addData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAddDialog = false;
            }
        },
        
        async updateDataFun(){
            this.updateData.fileNum = parseInt(this.updateData.fileNum);
            this.updateData.filePathJson = JSON.stringify(this.filePathJson);
            this.updateData.departmentJson = '';
            for(let index in this.businessList){
                if(index==0){
                    this.updateData.departmentJson = this.businessList[index];
                }else{
                    this.updateData.departmentJson = this.updateData.departmentJson+','+ this.businessList[index];
                }
            }
            let res  = await api.sealVerificationUpdateAsync(this.updateData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }
            this.updateData = {};
        },
        async isUpdateDialogShow(row){
            if(row.departmentJson.length>0){
                this.businessList = row.departmentJson.split(',');
            }else{
                this.businessList = [];
            }
            this.filePathJson = JSON.parse(row.filePathJson)?JSON.parse(row.filePathJson):[];
            this.isUpdateDialog = true;
            this.updateData = row;
           
        },
        deleteMechanismTip(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteMechanism(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteMechanism(row){
            console.log(row.id);
            let res  = await api.deleteMechanism(row.id);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        async loadingUserList(){
            let res  = await api.QueryUsersPager(this.conditionUserData);
            this.userList = res.data.data.data;
            this.userTotal = res.data.data.totalCount;
        },
        selectUserData(){
            this.conditionUserData.page = 1;
            this.loadingUserList();
        },
        resetUserData(){
            this.conditionUserData = {
                Keyword:'',
                Name:'',
                Sex:'',
                Phone:'',
                MinZu:'',
                IdCard:'',
                HuKouType:'',
                ZzMm:'',
                ZgXl:'',
                page:1,
                pageSize:10,
            },
            this.loadingUserList();
        },
        selectAddData(type){
            this.selectType = type;
            this.isAgentListDialog = true;
        },
        affirm(row){
            if(this.isAddDialog){
                if(this.selectType == 0){
                    this.addData.adminUserId = row.id;
                    this.addData.agent = row.name;
                }else if(this.selectType == 1){
                    this.addData.cCtoId = row.id;
                    this.addData.cCtoName = row.name;
                }else if(this.selectType == 1){
                    this.addData.cCtoId = row.id;
                    this.addData.cCtoName = row.name;
                }else if(this.selectType == 2){
                    this.addData.firstShenId = row.id;
                    this.addData.firstShenName = row.name;
                }else if(this.selectType == 3){
                    this.addData.endShenId = row.id;
                    this.addData.endShenName = row.name;
                }
            }else{
                if(this.selectType == 0){
                    this.updateData.adminUserId = row.id;
                    this.updateData.agent = row.name;
                }else if(this.selectType == 1){
                    this.updateData.cCtoId = row.id;
                    this.updateData.cCtoName = row.name;
                }else if(this.selectType == 1){
                    this.updateData.cCtoId = row.id;
                    this.updateData.cCtoName = row.name;
                }else if(this.selectType == 2){
                    this.updateData.firstShenId = row.id;
                    this.updateData.firstShenName = row.name;
                }else if(this.selectType == 3){
                    this.updateData.endShenId = row.id;
                    this.updateData.endShenName = row.name;
                }
            }
            this.isUserDialog = false;
        },
        async fileUpload(file){
            let res = await api.uploadOther(file.file);
            console.log(res);
            this.filePathJson.push(res);
            console.log(this.filePathJson);
        },
        closeViewer(){
            this.showBigImg = false;
        },
        showImg(img){
            this.showBigImgList = [img];
            this.showBigImg = true;
        },
        deleteImg(index){
            this.filePathJson.splice(index,1);

        },
        isAuditDialogShow(row){
            if(row.departmentJson.length>0){
                this.businessList = row.departmentJson.split(',');
            }else{
                this.businessList = [];
            }
            this.auditData = row;
            this.filePathJson = JSON.parse(row.filePathJson)?JSON.parse(row.filePathJson):[];
            this.auditDialogShow = true;
        },
        async auditDataFun(){
            this.auditData.fileNum = parseInt(this.auditData.fileNum);
            this.auditData.filePathJson = JSON.stringify(this.filePathJson);
            let res  = await api.sealVerificationExamineAsync(this.auditData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.auditDialogShow = false;
            }else{
                this.auditDialogShow = false;
            }
            this.auditData = {};
        },
        isDeleteShow(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sealVerificationDeleteAsync(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async sealVerificationDeleteAsync(row){
            console.log(row);
            let res = await api.sealVerificationDeleteAsync(row.id);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        async loadingAgentList(){
            let res  = await api.QueryUsers(this.conditionAgentData);
            this.agentList = res.data.data.data;
            this.agentTotalCount = res.data.data.totalCount;
        },
        selectAgentData(){
            this.conditionAgentData.page = 1;
            this.loadingAgentList();
        },
        resetAgentData(){
            this.conditionAgentData = {
                Name:'',
                Phone:'',
                page:1,
                pageSize:10,
            },
            this.loadingAgentList();
        },
        affirmAgent(row){
            console.log(row);
            if(this.isAddDialog){
                if(this.selectType == 0){
                    this.addData.adminUserId = row.id;
                    this.addData.agent = row.name;
                }else if(this.selectType == 1){
                    this.addData.cCtoId = row.id;
                    this.addData.cCtoName = row.name;
                }else if(this.selectType == 1){
                    this.addData.cCtoId = row.id;
                    this.addData.cCtoName = row.name;
                }else if(this.selectType == 2){
                    this.addData.firstShenId = row.id;
                    this.addData.firstShenName = row.name;
                }else if(this.selectType == 3){
                    this.addData.endShenId = row.id;
                    this.addData.endShenName = row.name;
                }
            }else{
                if(this.selectType == 0){
                    this.updateData.adminUserId = row.id;
                    this.updateData.agent = row.name;
                }else if(this.selectType == 1){
                    this.updateData.cCtoId = row.id;
                    this.updateData.cCtoName = row.name;
                }else if(this.selectType == 1){
                    this.updateData.cCtoId = row.id;
                    this.updateData.cCtoName = row.name;
                }else if(this.selectType == 2){
                    this.updateData.firstShenId = row.id;
                    this.updateData.firstShenName = row.name;
                }else if(this.selectType == 3){
                    this.updateData.endShenId = row.id;
                    this.updateData.endShenName = row.name;
                }
            }
            this.isAgentListDialog = false;
        },
        handleCurrentChangeAgent(page){
            this.conditionAgentData.page = page;
            this.loadingAgentList();
        },


        // 重置部门列表
        resetDepartment(){
            this.departmentConditionData = {
                Name:'',
                page:1,
                pageSize:10,
            }
            this.geDepartment();
        },
        // 查询部门
        selectDepartmentData(){
            this.departmentConditionData.page = 1;
            this.geDepartment();
        },
        // 获取部门列表
        async geDepartment(){
            let res  = await api.QueryCauseList(this.departmentConditionData);
            console.log(res);
            this.departmentList = res.data.data.data;
            this.departmentTotalCount = res.data.data.totalCount;
           
            this.$forceUpdate();
        },
        // 部门列表分页
        handleDepartmentCurrentChange(page){
            this.departmentConditionData.page = page;
            this.getDepartment();
        },
        // 确认选择部门
        affirmDepartment(row,index){
            this.businessList.push(row.name);
            this.departmentList[index].isSelected = this.$set(this.departmentList[index],'isSelected',true);
            this.$forceUpdate();
            this.$message({
                message: '添加成功',
                type: 'success'
            });
        },
        closeBusiness(index){
            this.businessList.splice(index,1);
            this.$forceUpdate();
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 8px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 7px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 150px;
            }
            .value{
                width: 215px;
                display: flex;
                align-items: center;
            }
            .item-imgs{
                width: 610px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .item-img{
                    position: relative;
                    margin-right: 10px;
                    margin-bottom: 10px;
                    .icon{
                        right: 0;
                        top: 0;
                        position:absolute;
                        z-index: 100;
                        color: #ffffff;
                        background-color: #000000;
                        width: 18px;
                        height: 18px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }

                }
            }
            /deep/.el-input.is-disabled .el-input__inner{
                color:#606266
            }
        }
        .item-b{
            width: 100%;
        }
        .dialog-footer{
            width:100%;
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
